<template>
    <div class="" style="">
      <div class="topImgContent">
        <div class="topImgTitleContent">
          <div class="topImgTitle">企业联盟</div>
          <div class="topImgsubTitle">FUTURE SCIENCE CITY NEWS</div>
        </div>
      </div>
      <div class="commonTabContent e-flex">
        <div class="commonTabCenter e-flex">
          <div v-for="(item, index) in tabs" :class="'commonTab ' + (index == tabIndex ? 'commonTabActive' : '')" @click="changeTab(item, index)">{{ item.name }}</div>
        </div>
      </div>
      <div class="" style="justify-content: center;">
        <div class="e-flex ue_list" v-for="(item, index) in list" v-if="index % 5 == 0">
            <div class="ue_listBlock ue_listBlock_ml0" @click="goDetail(item.id)">
                <div class="e-flex ue_listBlockImgContent">
                    <img class="ue_listBlockImg" :src="item.iconUrl">
                </div>
                <div class="e-line-1 ue_listBlockText">{{ item.name }}</div>
            </div>
            <div class="ue_listBlock" v-if="list[index + 1]" @click="goDetail(list[index + 1].id)">
                <div class="e-flex ue_listBlockImgContent">
                    <img class="ue_listBlockImg" :src="list[index + 1].iconUrl">
                </div>
                <div class="e-line-1 ue_listBlockText">{{ list[index + 1].name }}</div>
            </div>
            <div class="ue_listBlock" v-if="list[index + 2]" @click="goDetail(list[index + 2].id)">
                <div class="e-flex ue_listBlockImgContent">
                    <img class="ue_listBlockImg" :src="list[index + 2].iconUrl">
                </div>
                <div class="e-line-1 ue_listBlockText">{{ list[index + 2].name }}</div>
            </div>
            <div class="ue_listBlock" v-if="list[index + 3]" @click="goDetail(list[index + 3].id)">
                <div class="e-flex ue_listBlockImgContent">
                    <img class="ue_listBlockImg" :src="list[index + 3].iconUrl">
                </div>
                <div class="e-line-1 ue_listBlockText">{{ list[index + 3].name }}</div>
            </div>
            <div class="ue_listBlock" v-if="list[index + 4]" @click="goDetail(list[index + 4].id)">
                <div class="e-flex ue_listBlockImgContent">
                    <img class="ue_listBlockImg" :src="list[index + 4].iconUrl">
                </div>
                <div class="e-line-1 ue_listBlockText">{{ list[index + 4].name }}</div>
            </div>
        </div>
      </div>
      <div class="noDataContent" v-if="list.length == 0">
        <img class="noDataImg" src="@/assets/images/noDataImg.png">
        <div class="noDataText">暂无内容</div>
      </div>
      <div class="e-flex pd_paginationContent">
        <el-pagination background layout="prev, pager, next, jumper" :page-size="20" :total="recordsTotal" @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </template>
  
  <script>
    import '../../styles/unionEnterprises.css'
    export default {
      name: 'unionEnterprises',
      data () {
        return {
          tabs: [{
            name: '全部分类',
            id: ''
          }],
          tabIndex: 0,
          page: 1,
          list: [],
          recordsTotal: 0
        }
      },
      created() {
        this.getType()
        this.getList()
      },
      methods: {
        changeTab(item, index) {
          this.tabIndex = index
          this.getList()
        },
        goDetail(id) {
          this.$router.push({ path: '/unionEnterprises/unionEnterprisesDetail', query: {id: id}})
        },
        pageChange(e) {
            this.page = e
            this.getList()
        },
        getType() {
          this.request({
              url: 'companyLeague/typeList?page=1&limit=99',
              method: 'get',
              data: {}
          }).then(res => {
              this.tabs = this.tabs.concat(res.data)
          })
        },
        getList() {
          this.request({
              url: 'companyLeague/list?page=' + this.page + '&limit=20&typeId=' + this.tabs[this.tabIndex].id,
              method: 'get',
              data: {}
          }).then(res => {
              this.list = res.data
              this.recordsTotal = res.recordsTotal
          })
        }
      }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/view/unionEnterprises/index.vue